// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwWidget from 'viewmodel/AwWidgetViewModel';
import AwSearchBox from 'viewmodel/AwSearchBoxViewModel';
import AwList from 'viewmodel/AwListViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/DesTeamService', () => import('js/DesTeamService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaversion": "1.0.0",
    "data": {
        "properties": {
            "displayName": "{{i18n.properties}}",
            "type": "STRING"
        },
        "teamName": {
            "displayName": "{{i18n.teamName}}",
            "isEditable": "false",
            "type": "STRING"
        },
        "description": {
            "displayName": "{{i18n.teamDescription}}",
            "isEditable": "false",
            "type": "STRING"
        },
        "teamMembers": {
            "displayName": "{{i18n.teamMembers}}",
            "type": "STRING"
        },
        "searchBox": {
            "displayName": "{{i18n.searchString}}",
            "type": "STRING",
            "dbValue": ""
        },
        "searchBoxPlaceHolder": {
            "dbValue": "{{i18n.searchString}}"
        }
    },
    "lifecycleHooks": {
        "onInit": {
            "action": "getTeam",
            "observers": [
                "props.accsessionid",
                "props.teamid",
                "props.collaborationspaceid"
            ]
        },
        "onMount": {
            "action": "initialize_DataProvider"
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "teamid": {
            "type": "string"
        }
    },
    "dataProviders": {
        "listTeamMembersProvider": {
            "action": "getTeamMembers",
            "response": "{{data.members}}",
            "totalFound": "{{data.totalFound}}",
            "commandsAnchor": "des_removeTeamMemberCommandAnchor"
        }
    },
    "actions": {
        "initialize_DataProvider": {
            "actionType": "dataProvider",
            "method": "listTeamMembersProvider"
        },
        "doSearch": {
            "actionType": "Event",
            "method": "Event",
            "inputData": {
                "events": [
                    {
                        "name": "searchInitiated",
                        "condition": "data.searchBox.dbValue && data.searchBox.dbValue.length>0",
                        "eventData": {
                            "eventName": "searchInitiated",
                            "searchInput": "{{data.searchBox.dbValue}}"
                        }
                    }
                ]
            }
        },
        "getTeamMembers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "searchInput": "{{data.searchBox.dbValue}}",
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "query ListTeamMembers($listTeamMembersInput: ListTeamMembersInput) {listTeamMembers(listTeamMembersInput: $listTeamMembersInput) }",
                        "variables": {
                            "listTeamMembersInput": {
                                "teamId": "{{props.teamid}}",
                                "searchOptions": {
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "members": "data.data.listTeamMembers.filterObj",
                "totalFound": "data.data.listTeamMembers.totalFound"
            },
            "events": {
                "failure": [
                    {
                        "name": "members.failure",
                        "condition": "members.hasError === true",
                        "eventData": {
                            "eventName": "desMembersFailure",
                            "eventData": "{{members}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "members.success",
                        "condition": "members.hasError === false",
                        "eventData": {
                            "eventName": "desMembersSuccess",
                            "eventData": "{{members}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "getTeam": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}"
                        },
                        "query": "query ListAllTeams($listTeamsInput: ListTeamsInput) {listAllTeams(listTeamsInput: $listTeamsInput)}",
                        "variables": {
                            "listTeamsInput": {
                                "filters": {
                                    "teamId": [
                                        "{{props.teamid}}"
                                    ]
                                },
                                "searchOptions": {
                                    "skip": 0,
                                    "limit": 10,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "teamListViewResponse": "data.data.listAllTeams.teamObjs[0]"
            },
            "events": {
                "failure": [
                    {
                        "name": "listAllTeams.failure",
                        "eventData": {
                            "eventName": "listAllTeamsFailure",
                            "eventData": "{{teamListViewResponse}}"
                        }
                    }
                ],
                "success": [
                    {
                        "name": "getTeamDetails.success",
                        "eventData": {
                            "eventName": "listAllTeamsSuccess",
                            "eventData": "{{teamListViewResponse}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "failure": [
                    {
                        "message": "queryFailedMessage"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "getTeamDetails": {
            "actionType": "JSFunction",
            "method": "getSelectedTeamDetailsOpen",
            "inputData": {
                "vmo": "{{data}}",
                "eventData": "{{teamListViewResponse}}"
            },
            "deps": "js/DesTeamService"
        },
        "publishToACCEventBus": {
            "actionType": "JSFunction",
            "method": "publish",
            "inputData": {
                "eventId": "{{parameters.eventName}}",
                "eventData": "{{parameters.eventData}}"
            },
            "deps": "js/accEventBus"
        },
        "removeMembers": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "collaborationspaceid": "{{props.collaborationspaceid}}",
                            "emailsOfMembersToRemove": [
                                "{{commandContext.vmo.cellHeader2}}"
                            ]
                        },
                        "query": "mutation RemoveTeamMembers( $removeTeamMembersInput: Json) {removeTeamMembers( removeTeamMembersInput: $removeTeamMembersInput )}",
                        "variables": {
                            "removeTeamMembersInput": {
                                "teamId": "{{props.teamid}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "removeTeamMembers": "data.data.removeTeamMembers"
            },
            "events": {
                "success": [
                    {
                        "name": "desRemoveTeamMembersSuccess",
                        "eventData": {
                            "eventName": "desRemoveTeamMembersSuccess",
                            "eventData": "{{removeTeamMembers}}"
                        }
                    }
                ]
            },
            "actionMessages": {
                "success": [
                    {
                        "message": "displayDesUpdateTeamSuccessMsg",
                        "condition": "removeTeamMembers.hasError === false"
                    },
                    {
                        "message": "displayDesCreateUserFailureMsg",
                        "condition": "removeTeamMembers.hasError === true"
                    }
                ]
            },
            "deps": "js/accHttpService"
        }
    },
    "onEvent": [
        {
            "eventId": "getTeamDetails.success",
            "action": "getTeamDetails",
            "inputArgs": {
                "eventName": "TeamOutputSuccess",
                "eventData": "{{teamListViewResponse}}"
            }
        },
        {
            "eventId": "searchInitiated",
            "action": "initialize_DataProvider"
        },
        {
            "eventId": "removeTeamMemberAction",
            "action": "removeMembers",
            "inputArgs": {
                "eventName": "removeTeamMemberAction",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "desRemoveTeamMembersSuccess",
            "action": "initialize_DataProvider"
        }
    ],
    "messages": {
        "displayTeamOutputSuccessMsg": {
            "messageText": "{{i18n.displayTeamOutputSuccessMsg}}"
        },
        "displayTeamOutputFailureMsg": {
            "messageText": "{{i18n.displayTeamOutputFailureMsg}}"
        }
    },
    "i18n": {
        "properties": [
            "DesTeamMessages"
        ],
        "teamMembers": [
            "DesTeamMessages"
        ],
        "teamName": [
            "DesTeamMessages"
        ],
        "teamDescription": [
            "DesTeamMessages"
        ],
        "message": [
            "DesTeamMessages"
        ],
        "displayTeamOutputSuccessMsg": [
            ""
        ],
        "displayTeamOutputFailureMsg": [
            ""
        ],
        "searchString": [
            "DesTeamMessages"
        ]
    },
    "_viewModelId": "DesTeamContents",
    "_uniqueViewModelId": "DesTeamContents",
    "ctx": {}
};

    /*
    <div class="des-image-styling-teamContents">
    <aw-panel>
        <aw-panel-body>
            <aw-flex-row>
                <aw-flex-column width="60f">
                    <aw-panel-section caption="Properties" collapsed="false">
                        <aw-widget prop="data.teamName"></aw-widget>
                        <aw-widget prop="data.description"></aw-widget>
                    </aw-panel-section>
                </aw-flex-column>
                <aw-flex-column width="60f">
                    <aw-panel-section caption="i18n.teamMembers" collapsed="false">
                        <aw-search-box prop="data.searchBox" placeholder="data.searchBoxPlaceHolder.dbValue" action="doSearch">
                        </aw-search-box>
                        <aw-list dataprovider="data.dataProviders.listTeamMembersProvider">
                            <aw-default-cell vmo="item"> </aw-default-cell>
                        </aw-list>
                    </aw-panel-section>
                </aw-flex-column>
            </aw-flex-row>
        </aw-panel-body>
    </aw-panel>
</div>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <div className="des-image-styling-teamContents">
        <AwPanel  revealAction={actions.reveal}>
            <AwPanelBody>
                <AwFlexRow>
                    <AwFlexColumn width="60f">
                        <AwPanelSection caption="Properties" collapsed="false">
                            <AwWidget {...getField("data.teamName", fields, $index, null, null )}>
                            </AwWidget>
                            <AwWidget {...getField("data.description", fields, $index, null, null )}>
                            </AwWidget>
                        </AwPanelSection>
                    </AwFlexColumn>
                    <AwFlexColumn width="60f">
                        <AwPanelSection caption={i18n.teamMembers} collapsed="false">
                            <AwSearchBox {...getField("data.searchBox", fields, $index, null, null )} placeholder={AwParseService.instance( "data.searchBoxPlaceHolder.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} action={actions.doSearch}>
                            </AwSearchBox>
                            <AwList dataprovider={dataProviders.listTeamMembersProvider} showDropArea={null} dndHandler={props.viewModel.dndHandler}>{({item, index})=>{ return <>                                <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                                </AwDefaultCell></> } }
                            </AwList>
                        </AwPanelSection>
                    </AwFlexColumn>
                </AwFlexRow>
            </AwPanelBody>
        </AwPanel>
    </div>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;